import React, { useCallback } from 'react'
import cn from 'classnames'
import { emptyArr } from 'util/arrays'

import RemovableRecipient from './RemovableRecipient'
import { styles } from './styles'

const List = ({
  className,
  recipients = emptyArr,
  onRemove,
  syncing,
  children,
}) => {
  const handleOnRemove = useCallback(
    recipient => {
      onRemove(recipient)
    },
    [onRemove]
  )

  return (
    <div
      className={cn('grui flex flex-auto recipient-list-container', className)}
      css={styles.list}
    >
      {recipients.map(recipient => {
        return (
          <RemovableRecipient
            className="recipient"
            key={recipient.id || recipient.email}
            recipient={recipient}
            recipients={recipients}
            onClick={handleOnRemove}
            syncing={syncing}
          />
        )
      })}
      {children}
    </div>
  )
}

export default List
